import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { ProductRequest, PriceList, ProductRequestV2 } from '@/types/ProductTypes';
import productService from '@/services/productService';

@Module({ namespaced: true })
export default class ProductModule extends VuexModule {
  products: PriceList = {} as PriceList;
  portiFolio = "";
  productRequest!: ProductRequestV2;

  get getPricelist() {
    return this.products;
  }

  @Mutation
  setProducts(products: PriceList) { this.products = products }

  @Mutation
  setPortiFolio(payload: ProductRequestV2) {
    this.productRequest = payload;
    this.portiFolio = payload.portiFolio;
  }

  @Action({ commit: 'setProducts' })
  async GetProducts(payload: ProductRequest): Promise<void | PriceList> {
    const products = await productService.fetchPortifolioProducts(payload)
    return products;
  }

  @Action({ commit: 'setProducts' })
  async GetPortiFolioOnlyProducts(payload: ProductRequestV2): Promise<void | PriceList> {
    const products = await productService.fetchPortifolioOnlyProducts(payload.portiFolio, payload.originator, payload.parameters)
    return products;
  }
}
